module.exports = __webpack_public_path__ + "static/media/buildingline.0fcacb23.svg";